"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const constants_1 = require("../../../constants");
const function_utils_1 = require("../../../utils/function-utils");
const Tooltip_1 = __importDefault(require("../../Tooltip/Tooltip"));
const SliderConstants_1 = require("../SliderConstants");
const SliderHelpers_1 = require("../SliderHelpers");
const SliderContext_1 = require("../SliderContext");
const tooltipPosition = constants_1.DialogPosition.TOP;
const SliderThumb = ({ className, index = 0, onMove = function_utils_1.NOOP, position = 0 }) => {
    const { max, min, ranged, value: valueOrValues, valueText: valueOrValuesText } = (0, SliderContext_1.useSliderSelection)();
    const value = ranged ? valueOrValues[index] : valueOrValues;
    const valueText = ranged ? valueOrValuesText[index] : valueOrValuesText;
    const { active, ariaLabel, ariaLabelledby, disabled, dragging, focused, shapeTestId, showValue } = (0, SliderContext_1.useSliderUi)();
    const { setActive, setFocused, setDragging } = (0, SliderContext_1.useSliderActions)();
    const ref = (0, react_1.useRef)(null);
    function handleBlur() {
        setFocused(null);
        setActive(null);
    }
    function handleFocus() {
        setFocused(index);
        setActive(index);
    }
    function handlePointerLeave() {
        setActive(null);
    }
    function handlePointerDown(e) {
        e.stopPropagation();
        setDragging(index);
        document.addEventListener("pointermove", onMove);
        document.addEventListener("pointerup", stopMove);
    }
    function stopMove() {
        setDragging(null);
        document.removeEventListener("pointermove", onMove);
        document.removeEventListener("pointerup", stopMove);
    }
    (0, react_1.useEffect)(() => {
        if (focused === index && ref && ref.current) {
            ref.current.focus();
        }
    }, [focused, index]);
    return ((0, jsx_runtime_1.jsx)(Tooltip_1.default
    // @ts-ignore TODO TS-migration the comment can be removed once TooltipProps will extend DialogProps, once Dialog is converted to TS
    , Object.assign({ 
        // @ts-ignore TODO TS-migration the comment can be removed once TooltipProps will extend DialogProps, once Dialog is converted to TS
        open: active === index || dragging === index, content: showValue ? null : valueText, position: tooltipPosition, showDelay: SliderConstants_1.TOOLTIP_SHOW_DELAY }, { children: (0, jsx_runtime_1.jsx)("div", Object.assign({ "aria-label": ariaLabel, "aria-labelledby": ariaLabelledby, "aria-valuemax": max, "aria-valuemin": min, "aria-valuenow": value, "aria-valuetext": valueText, "aria-disabled": disabled, className: (0, SliderHelpers_1.bem)("thumb", { dragging: dragging === index, focused: focused === index, disabled, [`index-${index}`]: true }, className), "data-testid": shapeTestId(`thumb-${index}`), onFocus: handleFocus, onBlur: handleBlur, onPointerDown: handlePointerDown, onPointerLeave: handlePointerLeave, ref: ref, role: "slider", style: { left: `${position}%` }, tabIndex: disabled ? -1 : 0 }, { children: showValue && (0, jsx_runtime_1.jsx)("label", Object.assign({ className: (0, SliderHelpers_1.bem)("thumb-label") }, { children: valueText })) })) })));
};
exports.default = SliderThumb;
